import React from 'react';
import Home from '../components/templates/Home';

const PageHome = () => (
  <Home />
);

export default PageHome;